import React from 'react';

import { FormInputBase, FormInputBaseProps } from './FormInputBase';

export type FormInputProps = FormInputBaseProps;

export const FormInput: React.FC<FormInputProps> = ({ type, ...props }) => {
  return <FormInputBase {...props} type={type} />;
};
